import { DateTime } from 'luxon';

export function formatDate(date: string | Date, format = 'MMM dd, yyyy'): string {
  return DateTime.fromISO(date.toString()).toFormat(format);
}

export function isWithinDays(date: string | Date, days: number): boolean {
  const targetDate = DateTime.fromISO(date.toString());
  const now = DateTime.now();
  const diffInDays = targetDate.diff(now, 'days').days;

  return diffInDays >= 0 && diffInDays <= days;
}
